import { useState } from 'react';
import { FAQS } from '@/mocks/celebrity';

export default function Faq() {
  const [open, setOpen] = useState<number>(0);

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: FAQS.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  };

  return (
    <section id="faq" className="mx-auto max-w-[900px] px-4 py-14 md:px-6 md:py-20">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="mx-auto max-w-xl text-center">
        <p className="text-xs font-semibold uppercase tracking-[0.22em] text-primary-600">FAQ</p>
        <h2 className="mt-1 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          吃瓜常见问题
        </h2>
        <p className="mt-3 text-sm text-foreground-600">
          关于“实锤”“同框”与时间线的判定，这里一次讲清楚。
        </p>
      </div>

      <div className="mt-8 space-y-3">
        {FAQS.map((f, idx) => {
          const isOpen = open === idx;
          return (
            <div
              key={f.q}
              className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
            >
              <button
                type="button"
                onClick={() => setOpen(isOpen ? -1 : idx)}
                aria-expanded={isOpen}
                className="flex w-full cursor-pointer items-center justify-between gap-4 p-4 text-left md:p-5"
              >
                <span className="flex items-start gap-3 text-[15px] font-medium text-foreground-900">
                  <i className={`mt-0.5 ${isOpen ? 'ri-question-answer-fill' : 'ri-question-line'} text-primary-500`} />
                  {f.q}
                </span>
                <i
                  className={`shrink-0 text-xl text-foreground-400 transition-transform ${isOpen ? 'ri-subtract-line' : 'ri-add-line'}`}
                />
              </button>
              {isOpen && (
                <p className="border-t border-background-200 px-4 py-4 text-sm leading-6 text-foreground-700 md:px-5">
                  {f.a}
                </p>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}